import React from 'react'

import {
  Button,
  ButtonGroup,
  HStack,
  Input,
  Switch,
  Text,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { useContactMethodsContext } from '../../contexts/ContactMethodsContext'

const AddContactMethodModal = () => {
  const {
    isAddOpen,
    closeAdd,
    handleAdd,
    newName,
    setNewName,
    modalActive,
    setModalActive,
  } = useContactMethodsContext()
  return (
    <Modal isOpen={isAddOpen} onClose={closeAdd} isCentered size='md'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Contact Method</ModalHeader>
        <ModalBody>
          <Input
            placeholder='Contact method name'
            value={newName}
            onChange={e => setNewName(e.target.value)}
            mb={3}
            autoFocus
          />
          <HStack>
            <Text>Active</Text>
            <Switch
              isChecked={modalActive}
              onChange={e => setModalActive(e.target.checked)}
              colorScheme='green'
            />
          </HStack>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup w='100%' justifyContent='space-between'>
            <Button onClick={closeAdd} variant='ghost' colorScheme='gray'>
              Cancel
            </Button>
            <Button
              colorScheme='blue'
              onClick={handleAdd}
              isDisabled={!newName.trim()}
            >
              Add
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default AddContactMethodModal
